import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_types_of_overtime_hours_is_the_fac_faili'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_types_of_overtime_hours_is_the_fac_faili',
  name: 'Which of the following types of overtime hours is the facility failing to pay workers as legally required?',
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'ORDINARY_OVERTIME_HOURS',
      text: 'Ordinary overtime hours',
      externalIds: [
        {
          id: 'wb-4--1',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_HOURS_PERFORMED_AT_NIGHT',
      text: 'Overtime hours performed at night',
      externalIds: [
        {
          id: 'wb-4--2',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_HOURS_PERFORMED_ON_WEEKLY_REST_DAYS',
      text: 'Overtime hours performed on weekly rest days',
      externalIds: [
        {
          id: 'wb-4--3',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OVERTIME_HOURS_PERFORMED_ON_PUBLIC_HOLIDAYS',
      text: 'Overtime hours performed on public holidays',
      externalIds: [
        {
          id: 'wb-4--4',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'IS_THE_FACILITY_FAILING_TO_PAY_WORKERS_CORRECTLY_FOR_ANY_OF_THE',
      text: 'Is the facility failing to pay workers correctly for any of these types of regular hours worked at a premium rate, as legally required: \n• Regular hours worked at night\n• Regular hours worked on weekly rest days\n• Regular hours worked on public holidays?',
      externalIds: [
        {
          id: 'wb-wag-13',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_PIECE_RATE_WORKERS_PAID_CORRECTLY_FOR_ORDINARY_HOURS_OF_WOR',
      text: 'Are piece rate workers paid correctly for ordinary hours of work when their piece rate earnings exceed minimum wage?',
      externalIds: [
        {
          id: 'wb-wag-14',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'ARE_OVERTIME_ALLOWANCES_PROVIDED_PAID_IN_LINE_WITH_LEGAL_REQUIR',
      text: 'Are overtime allowances provided/paid in line with legal requirements?',
      externalIds: [
        {
          id: 'wb-8',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'ORDINARY_OVERTIME_HOURS',
                'OVERTIME_HOURS_PERFORMED_AT_NIGHT',
                'OVERTIME_HOURS_PERFORMED_ON_WEEKLY_REST_DAYS',
                'OVERTIME_HOURS_PERFORMED_ON_PUBLIC_HOLIDAYS',
                'IS_THE_FACILITY_FAILING_TO_PAY_WORKERS_CORRECTLY_FOR_ANY_OF_THE',
                'ARE_PIECE_RATE_WORKERS_PAID_CORRECTLY_FOR_ORDINARY_HOURS_OF_WOR',
                'ARE_OVERTIME_ALLOWANCES_PROVIDED_PAID_IN_LINE_WITH_LEGAL_REQUIR',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wb-4',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 7450,
  sectionId: '2.2.3',
  impactArea: 'Compensation',
  impactAreaId: 'WAGES_AND_BENEFITS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
